import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppState } from '../app.service';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';

@Injectable({
  providedIn: 'root'
})
export class KyperDataApiService {
  API_URL: string = environment.apiBaseUrl
  kyper_user_save_content = '/users/kyper_users/save_content'
  kyper_user_schedule_complete_action = '/users/kyper_users/save_action_answers';
  kyper_submit_feedback_action = '/users/kyper_users/save_action_feedback';
  kyper_action_list = '/get_action_details'
  kyper_habit_list = '/get_habit_details'
  kyper_posts_lists = '/get_kyper_posts'
  kyper_user_replies = '/users/kyper_users/save_user_replies'
  kyper_user_commet = '/users/kyper_users/save_discussion_answers'
  kyper_user_likes = '/users/kyper_users/save_user_vote'
  kyper_habits_optIn = '//users/kyper_users/save_habit_opt_in'
  kyper_path_registration = '/users/kyper_users/update_path_registrations'
  kyper_saved_steps ='/get_all_saved_posts'
  constructor(private http: HttpClient, private appState: AppState, 
    private homev5Service: HomeV5Service) { }

  public updateContentScreenCompletion(data): Observable<any>{
    let input = {
      step_id:data.stepId,
      screen_id:data.screenId,
      screen_content_id:data.screenContentId,
      is_completed: true,
      is_content_viewed: data?.is_content_viewed || null,
     }
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL+this.kyper_user_save_content,input,{headers});
  }

  formatDate() {
     const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
   public schedule_commit_action_kyper(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL+this.kyper_user_schedule_complete_action,data,{headers});
   }
  
   public submitActionCompletionFeedback(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL+this.kyper_submit_feedback_action,data,{headers});
  }

   public getActionsList(data): Observable<any> {
      const headers = new HttpHeaders();
     headers.set("Authorization", localStorage.getItem("token"));
     const params = new HttpParams()
           .append('path_id', data.path_id);
      return this.http.get(this.API_URL + this.kyper_action_list, { headers,params });
    }
  
    getActions(pathId: number) {
      const requestData = {
        'path_id': pathId
      }
      this.getActionsList(requestData).subscribe((response) => {
        console.log("action query response", response)
        this.appState.set('todoActions',response.actions)
      }, (error) => {
        console.log('getActions error :', error);
      })
    }
   public getHabitsList(data): Observable<any> {
       const headers = new HttpHeaders();
        headers.set("Authorization", localStorage.getItem("token"));
       const params = new HttpParams()
         .append('path_id', data.path_id);
       return this.http.get(this.API_URL + this.kyper_habit_list, { headers, params });
     }
   
  getHabits(pathId: number) {
       const requestData = {
         'path_id': pathId
       }
       this.getHabitsList(requestData).subscribe((response) => {
         this.appState.set('todoRoutines',this.homev5Service.removeDuplicates(response.habits, "habitGroupId"))
       }, (error) => {
         console.log('getActions error :', error);
       })
  }
  
  postKyperUserReplies(data): Observable<any> {
     let comment = {
       screen_content_id: data.screenContentId,
       reply_text: data.replyText,
       reply_type: 'question_reply/action_reply/ habit_reply',
       reply_level: 1,
       user_ids: data.user_ids,
     }
     let subComment = {
       screen_content_id: data.screenContentId,
       root_id:data.rootId,
       reply_text: data.replyText,
       reply_type: 'question_sub_reply/action_sub_reply/ habit_sub_reply',
       reply_level: 2,
       user_ids: data.user_ids,

     }
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL+this.kyper_user_replies,data,{headers});
  }
    
  postKyperUserComment(data): Observable<any> {
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL+this.kyper_user_commet,data,{headers});
  }

  postKyperUserLikes(data): Observable<any> {
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL+this.kyper_user_likes,data,{headers});
  }
   setKyperHabitOpttIn(data): Observable<any>{
    let input = {
      step_id:data.stepId,
      screen_id:data.screenId,
      screen_content_id:data.screenContentId,
      is_completed:true
     }
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL+this.kyper_user_save_content,input,{headers});
  }

  kyperUpdatePathRegistration(data): Observable<any>{

    const headers = new HttpHeaders();
  let params = new HttpParams()
  .append('selected_day_part', data.selected_day_part)
  .append('schedule_day', data.schedule_day)
  .append('email_reminder_enabled', data.path_data.email_reminder_enabled)
  .append('login_reminder_time_utc', data.path_data.login_reminder_time_utc)
  .append('login_reminder_enabled', data.path_data.login_reminder_enabled)
  .append('device_registration_id', data.path_data.device_registration_id)
  .append('push_reminder_enabled', data.path_data.push_reminder_enabled)
  .append('social_reminder_enabled', data.path_data.social_reminder_enabled)
  .append('social_email_enabled', data.path_data.social_email_enabled)
  .append('selected_learning_day', data.path_data.selected_learning_day)
  .append('login_reminder_weekday', data.path_data.login_reminder_weekday)
  .append('login_reminder_date', data.path_data.login_reminder_date);
    
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.put(this.API_URL+this.kyper_path_registration,data,{headers});
  }

  kyperSavedSteps(): Observable<any> {
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));
    return this.http.get(this.API_URL + this.kyper_saved_steps, { headers });
  }
  
  public getPostsList(data): Observable<any> {
     let isTranslate = this.appState.get('selectedLanguage') ? true : false
     let language = this.appState.get('selectedLanguage') ? this.appState.get('selectedLanguage') : null
      const headers = new HttpHeaders();
     headers.set("Authorization", localStorage.getItem("token"));
     const params = new HttpParams()
           .append('path_id', data.path_id)
           .append('page', data.page)
           .append('user_language', language)
           .append('is_translate', isTranslate);
      return this.http.get(this.API_URL + this.kyper_posts_lists, { headers,params });
  }
}
